// extracted by mini-css-extract-plugin
export var avatarContainer = "_5s-0";
export var avatarTypingWave = "_5s-i";
export var gray = "_5s-f";
export var green = "_5s-c";
export var icon = "_5s-9";
export var image = "_5s-1";
export var lg = "_5s-6";
export var md = "_5s-5";
export var presenceDot = "_5s-b";
export var red = "_5s-d";
export var sm = "_5s-4";
export var status = "_5s-a";
export var typingDot = "_5s-h";
export var typingPill = "_5s-g";
export var xl = "_5s-7";
export var xs = "_5s-3";
export var xxl = "_5s-8";
export var xxs = "_5s-2";
export var yellow = "_5s-e";